import { upperFirst } from 'es-toolkit';
import { mergeClasses } from 'minimal-shared/utils';

import { labelClasses } from './classes';
import { LabelRoot, LabelIcon } from './styles';

// ----------------------------------------------------------------------

/**
 * 작은 상태 배지. `variant`·`color` 만으로 쓰는 곳이 많다.
 *
 * ⚠️ **프롭은 전부 선택이다** — 좁히면 `<Label color variant>{…}</Label>` 조차
 * 「sx·endIcon·startIcon·className·disabled 가 없다」고 튕긴다.
 */
export type LabelProps = {
  sx?: any;
  endIcon?: React.ReactNode;
  children?: React.ReactNode;
  startIcon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  variant?: string;
  color?: string;
} & Record<string, any>;

export function Label({
  sx,
  endIcon,
  children,
  startIcon,
  className,
  disabled,
  variant = 'soft',
  color = 'default',
  ...other
}: LabelProps) {
  return (
    <LabelRoot
      color={color}
      variant={variant}
      disabled={disabled}
      className={mergeClasses([labelClasses.root, className])}
      sx={sx}
      {...other}
    >
      {startIcon && <LabelIcon className={labelClasses.icon}>{startIcon}</LabelIcon>}

      {typeof children === 'string' ? upperFirst(children) : children}

      {endIcon && <LabelIcon className={labelClasses.icon}>{endIcon}</LabelIcon>}
    </LabelRoot>
  );
}
